import { render } from "./ChilePage.vue?vue&type=template&id=b5878fdc&scoped=true"
import script from "./ChilePage.vue?vue&type=script&lang=js"
export * from "./ChilePage.vue?vue&type=script&lang=js"

import "./ChilePage.vue?vue&type=style&index=0&id=b5878fdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5878fdc"]])

export default __exports__